module.exports = __webpack_public_path__ + "inputs/img/school.3fd93383.png";